import React, { useState, useEffect } from "react";

import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import DatePicker from "react-datepicker2";
import moment from "moment-jalaali";
import { NotificationManager } from "react-notifications";
import { confirmAlert } from "react-confirm-alert";

import KeyboardArrowLeftIcon from "@material-ui/icons/KeyboardArrowLeft";
import Button from "@material-ui/core/Button";

import styles from "../../../styles/management.module.css";
import { devicesActions } from "../../store";
import { useNavigate } from "react-router";
import Conf from "../../../conf";

let find = false;
let device;

const Edit = () => {
    const history = useNavigate();
    const Dispatch = useDispatch();

    const { DeviceID } = useParams();
    const isNew = DeviceID === "new";

    const devices = useSelector((state) => Object.values(state.devices.items));

    const [name, setName] = useState("");
    const [id, setId] = useState("");
    const [phone, setPhone] = useState("");

    const [subscriptionStartDate, setsubscriptionStartDate] = useState(moment());
    const [subscriptionEndDate, setsubscriptionEndDate] = useState(moment().add(1, "year"));

    const update = () => {
        fetch(`${Conf.server_address}/devices`, { method: "GET", credentials: "include" })
            .then((response) => {
                return response.status === 200 ? response.json() : { error: response.status };
            })
            .then((response) => {
                if (!response.error) {
                    Dispatch(devicesActions.refresh(response));
                }
            });
    };

    useEffect(() => {
        find = false;
    }, []);

    useEffect(() => {
        if (!find && !isNew) {
            const DeviceID_ = parseInt(DeviceID);

            device = devices.find((Row) => Row.id === DeviceID_);
            if (device) {
                setName(device.name);
                setId(device.uniqueId);
                setPhone(device.phone);

                setsubscriptionStartDate(device.attributes.subscriptionStartDate ? moment(device.attributes.subscriptionStartDate) : moment());
                setsubscriptionEndDate(device.attributes.subscriptionEndDate ? moment(device.attributes.subscriptionEndDate) : moment());

                find = true;
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [devices]);

    const save = () => {
        if (name.length === 0) NotificationManager.error("لطفا نام را وارد کنید", "", 2500);
        else if (id.length === 0) NotificationManager.error("لطفا id را وارد کنید", "", 2500);
        else if (isNew) {
            let data = {
                category: null,
                contact: "",
                disabled: false,
                groupId: 0,
                id: -1,
                lastUpdate: null,
                model: "",
                name: name,
                phone: phone,
                status: null,
                uniqueId: id,
                attributes: {
                    createtionDate: moment(),
                    subscriptionStartDate: subscriptionStartDate,
                    subscriptionEndDate: subscriptionEndDate,
                },
            };

            fetch(`${Conf.server_address}/devices`, {
                method: "POST",
                headers: { "Content-Type": "application/json", accept: "*/*" },
                credentials: "include",
                body: JSON.stringify(data),
            })
                .then((response) => {
                    return response.status === 200 ? response.json() : { error: response.status };
                })
                .then((response) => {
                    if (response.error) {
                        NotificationManager.error("این خودرو موجود میباشد", "", 2500);
                    } else {
                        update();
                        NotificationManager.success("خودرو با موفقیت اضافه شد", "", 4000);
                        history("/management/devices");
                    }
                });
        } else {
            let data = {
                ...device,
                name: name,
                phone: phone,
                uniqueId: id,
                attributes: {
                    ...device.attributes,
                    subscriptionStartDate: subscriptionStartDate,
                    subscriptionEndDate: subscriptionEndDate,
                },
            };

            fetch(`${Conf.server_address}/devices/${device.id}`, {
                method: "PUT",
                headers: { "Content-Type": "application/json", accept: "*/*" },
                credentials: "include",
                body: JSON.stringify(data),
            })
                .then((response) => {
                    return response.status === 200 ? response.json() : { error: response.status };
                })
                .then((response) => {
                    if (response.error) {
                        NotificationManager.error("خطا در ویرایش خودرو", "", 2500);
                    } else {
                        NotificationManager.success("خودرو با موفقیت ویرایش شد", "", 4000);
                        update();
                    }
                });
        }
    };

    const deleteConfirm = () => {
        if (isNew) {
            history("/management/devices");
        } else {
            confirmAlert({
                customUI: ({ onClose }) => {
                    return (
                        <div className={styles.custom_ui}>
                            <h1>آیا از حذف خودروی "{name}" مطمعن هستید ؟</h1>
                            <button onClick={onClose}>خیر</button>
                            <button
                                onClick={() => {
                                    onClose();

                                    fetch(`${Conf.server_address}/devices/${device.id}`, {
                                        method: "DELETE",
                                        headers: { "Content-Type": "application/json", accept: "*/*" },
                                        credentials: "include",
                                    }).then((response) => {
                                        if (response.status === 204) {
                                            update();
                                            NotificationManager.success("خودرو با موفقیت حذف شد", "", 4000);
                                            history("/management/devices");
                                        } else {
                                            NotificationManager.error("خطا در حذف خودرو", "", 2500);
                                        }
                                    });
                                }}
                            >
                                بله
                            </button>
                        </div>
                    );
                },
            });
        }
    };

    return (
        <div className={styles.main}>
            <div className={styles.header}>
                <div className={styles.headerRight}>
                    دستگاه ها{" > "}
                    {isNew ? "دستگاه جدید" : name}
                </div>
                <div className={styles.headerLeft} onClick={() => history("/management/devices")}>
                    <KeyboardArrowLeftIcon className={styles.exitIcon} />
                    بازگشت
                </div>
            </div>
            <div className={styles.body}>
                <div className={styles.contents2}>
                    <div className={styles.form}>
                        <div className={styles.row}>
                            <div className={styles.clearfix}>
                                <label className={styles.label}>نام:</label>
                                <input type="text" id="name" className={styles.input} value={name} onChange={(event) => setName(event.target.value)} />
                            </div>
                            <div className={styles.clearfix}>
                                <label className={styles.label}>ID:</label>
                                <input type="id" className={styles.input} value={id} onChange={(event) => setId(event.target.value)} />
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.clearfix}>
                                <label className={styles.label}>شروع اشتراک:</label>
                                <DatePicker className={styles.inputDate} value={subscriptionStartDate} isGregorian={false} onChange={(startDate) => setsubscriptionStartDate(startDate)} />
                            </div>
                            <div className={styles.clearfix}>
                                <label className={styles.label}>پایان اشتراک:</label>
                                <DatePicker className={styles.inputDate} value={subscriptionEndDate} isGregorian={false} onChange={(endDate) => setsubscriptionEndDate(endDate)} />
                            </div>
                        </div>
                        <div className={styles.row}>
                            <div className={styles.clearfix}>
                                <label className={styles.label}>تلفن دستگاه:</label>
                                <input type="phone" className={styles.inputPhone} value={phone} onChange={(event) => setPhone(event.target.value)} />
                            </div>
                            <div className={styles.clearfix}>
                                <Button className={styles.save} variant="contained" component="label" onClick={() => save()}>
                                    {isNew ? "+ افزودن" : "ویرایش"}
                                </Button>
                                <Button className={styles.remove} style={{ backgroundColor: "#d91717 !important" }} variant="contained" component="label" onClick={() => deleteConfirm()}>
                                    {isNew ? "بیخیال" : "حذف"}
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Edit;
